(function () {
  let firstPartyAssetPattern =
    /\/assets\/(affirmDirectCheckout|affirmUiGuard|affirmShopify|termsAcceptance|theme)\.js/;

  function getExceptionValues(event) {
    return event.exception && event.exception.values ? event.exception.values : [];
  }

  function getFrames(event) {
    let frames = [];
    let values = getExceptionValues(event);

    for (let index = 0; index < values.length; index += 1) {
      let stacktrace = values[index].stacktrace;

      if (!stacktrace || !stacktrace.frames) {
        continue;
      }

      frames = frames.concat(stacktrace.frames);
    }

    return frames;
  }

  function frameFilename(frame) {
    return frame.filename || frame.abs_path || "";
  }

  function getErrorMessage(event) {
    let values = getExceptionValues(event);

    if (values.length && values[0].value) {
      return values[0].value;
    }

    if (event.message) {
      return event.message;
    }

    return "";
  }

  function hasFirstPartyFrame(frames) {
    for (let index = 0; index < frames.length; index += 1) {
      if (firstPartyAssetPattern.test(frameFilename(frames[index]))) {
        return true;
      }
    }

    return false;
  }

  function hasVendorTrackedFrame(frames) {
    for (let index = 0; index < frames.length; index += 1) {
      let filename = frameFilename(frames[index]);

      if (
        filename.indexOf("/extensions/") !== -1 ||
        filename.indexOf("/web-pixels") !== -1
      ) {
        return true;
      }
    }

    return false;
  }

  function hasFrameMatching(frames, pattern) {
    for (let index = 0; index < frames.length; index += 1) {
      if (pattern.test(frameFilename(frames[index]))) {
        return true;
      }
    }

    return false;
  }

  function isTermsLoadFailureMessage(message) {
    return message === "terms content load failed";
  }

  function isShopJsDynamicImportFailure(message) {
    return /Failed to fetch dynamically imported module:.*shopifycloud\/shop-js/.test(message);
  }

  function isShopJsModuleImportFailure(message, frames) {
    if (message.indexOf("Importing a module script failed") === -1) {
      return false;
    }

    return (
      /shopifycloud\/shop-js/.test(message) ||
      hasFrameMatching(frames, /shopifycloud\/shop-js/)
    );
  }

  function isJsonLdTelephoneParserError(message, frames) {
    if (!/hasOwnProperty\.call\([^,]+,"telephone"\)/.test(message)) {
      return false;
    }

    return hasFrameMatching(frames, /extract(?:Filtered)?SchemaValuesFromJSONLD/);
  }

  function isBrowserExtensionTabError(message) {
    return (
      message === "Error: Invalid call to runtime.sendMessage(). Tab not found." ||
      message === "Invalid call to runtime.sendMessage(). Tab not found."
    );
  }

  function isInAppBrowserWebkitError(message, frames) {
    if (!/webkit\.messageHandlers/.test(message)) {
      return false;
    }

    return hasFrameMatching(frames, /sendDataToNative|setupIosCallbackHandler/);
  }

  function isShopJsInstrumentedFetchFailure(message, frames) {
    if (message !== "Failed to fetch" && message.indexOf("TypeError: Failed to fetch") === -1) {
      return false;
    }

    if (hasFirstPartyFrame(frames) || hasVendorTrackedFrame(frames)) {
      return false;
    }

    return (
      hasFrameMatching(frames, /instrument\/fetch/) &&
      hasFrameMatching(frames, /shopifycloud\/shop-js/)
    );
  }

  function isGlobalCodeLoadFailed(message, frames) {
    if (message.indexOf("Load failed") === -1) {
      return false;
    }

    if (hasFirstPartyFrame(frames) || hasVendorTrackedFrame(frames)) {
      return false;
    }

    return hasFrameMatching(frames, /global code\(/);
  }

  function isStorefrontPageUrlLoadFailed(message, frames) {
    if (message.indexOf("Load failed") === -1) {
      return false;
    }

    if (hasFirstPartyFrame(frames) || hasVendorTrackedFrame(frames)) {
      return false;
    }

    if (frames.length !== 1) {
      return false;
    }

    return /^https:\/\/[^/]+\/(?:cart|collections|products|blogs|pages)\//.test(
      frameFilename(frames[0])
    );
  }

  function isOldBrowserShopifySyntaxError(message, frames) {
    if (
      message.indexOf("Unexpected reserved word") === -1 &&
      message.indexOf("Unexpected token") === -1
    ) {
      return false;
    }

    if (hasFirstPartyFrame(frames)) {
      return false;
    }

    return hasFrameMatching(
      frames,
      /shopifycloud\/shop-js|standard-actions|storefront\/standard-actions/
    );
  }

  function isShopPlatformAbortError(message, frames) {
    if (message.indexOf("AbortError") === -1) {
      return false;
    }

    if (hasFirstPartyFrame(frames) || hasVendorTrackedFrame(frames)) {
      return false;
    }

    return hasFrameMatching(
      frames,
      /shopifycloud\/shop-js|\/wpm\/|shop_events_listener/
    );
  }

  function isShopifyPayLoadFailed(message, frames) {
    if (message.indexOf("Load failed") === -1) {
      return false;
    }

    if (hasFirstPartyFrame(frames)) {
      return false;
    }

    return hasFrameMatching(frames, /shopify_pay\/storefront/);
  }

  function isShopEventsListenerLoadFailed(message, frames) {
    if (message.indexOf("Load failed") === -1) {
      return false;
    }

    if (hasFirstPartyFrame(frames)) {
      return false;
    }

    return hasFrameMatching(frames, /shop_events_listener/);
  }

  function isWpmLoadFailed(message, frames) {
    if (message.indexOf("Load failed") === -1) {
      return false;
    }

    if (hasFirstPartyFrame(frames)) {
      return false;
    }

    for (let index = 0; index < frames.length; index += 1) {
      let filename = frameFilename(frames[index]);

      if (filename.indexOf("/wpm/") === -1) {
        continue;
      }

      if (frames[index].function === "produce") {
        return false;
      }

      return true;
    }

    return false;
  }

  function isGenericNetworkLoadFailed(message, frames) {
    if (message.indexOf("NetworkError: Load failed") === -1) {
      return false;
    }

    if (hasFirstPartyFrame(frames)) {
      return false;
    }

    return frames.length === 0;
  }

  function isStorefrontPageUrlFetchFailed(message, frames) {
    if (message !== "Failed to fetch" && message.indexOf("Failed to fetch") === -1) {
      return false;
    }

    if (hasFirstPartyFrame(frames) || hasVendorTrackedFrame(frames)) {
      return false;
    }

    if (frames.length !== 1) {
      return false;
    }

    return /^https:\/\/[^/]+\/(?:cart|collections|products|blogs|pages)/.test(
      frameFilename(frames[0])
    );
  }

  function isBareInstrumentedFetchFailure(message, frames) {
    if (message !== "Failed to fetch" && message.indexOf("Failed to fetch") === -1) {
      return false;
    }

    if (hasFirstPartyFrame(frames) || hasVendorTrackedFrame(frames)) {
      return false;
    }

    if (!hasFrameMatching(frames, /instrument\/fetch/)) {
      return false;
    }

    return !hasFrameMatching(frames, /shopifycloud\/shop-js/);
  }

  function isInstrumentedFetchNoise(message, frames) {
    if (message !== "Failed to fetch" && message.indexOf("TypeError: Failed to fetch") === -1) {
      return false;
    }

    if (hasFirstPartyFrame(frames)) {
      return false;
    }

    if (!hasFrameMatching(frames, /instrument\/fetch/)) {
      return false;
    }

    return hasFrameMatching(
      frames,
      /shopifycloud\/perf-kit|\/wpm\/|shop_events_listener/
    );
  }

  function sentryShouldDropEvent(event) {
    let message = getErrorMessage(event);
    let frames = getFrames(event);

    if (isTermsLoadFailureMessage(message)) {
      return true;
    }

    if (isShopJsDynamicImportFailure(message)) {
      return true;
    }

    if (isShopJsModuleImportFailure(message, frames)) {
      return true;
    }

    if (isJsonLdTelephoneParserError(message, frames)) {
      return true;
    }

    if (isBrowserExtensionTabError(message)) {
      return true;
    }

    if (isInAppBrowserWebkitError(message, frames)) {
      return true;
    }

    if (isShopJsInstrumentedFetchFailure(message, frames)) {
      return true;
    }

    if (isGlobalCodeLoadFailed(message, frames)) {
      return true;
    }

    if (isStorefrontPageUrlLoadFailed(message, frames)) {
      return true;
    }

    if (isOldBrowserShopifySyntaxError(message, frames)) {
      return true;
    }

    if (isShopPlatformAbortError(message, frames)) {
      return true;
    }

    if (isShopifyPayLoadFailed(message, frames)) {
      return true;
    }

    if (isShopEventsListenerLoadFailed(message, frames)) {
      return true;
    }

    if (isWpmLoadFailed(message, frames)) {
      return true;
    }

    if (isGenericNetworkLoadFailed(message, frames)) {
      return true;
    }

    if (isStorefrontPageUrlFetchFailed(message, frames)) {
      return true;
    }

    if (isBareInstrumentedFetchFailure(message, frames)) {
      return true;
    }

    if (isInstrumentedFetchNoise(message, frames)) {
      return true;
    }

    return false;
  }

  window.sentryShouldDropEvent = sentryShouldDropEvent;
})();
